import { PaymentApi } from '@cibli/shared';

import api from './api';

export const createPaymentIntent = async (): Promise<PaymentApi.CreatePaymentIntentResponse> => {
  return api.post<PaymentApi.CreatePaymentIntentResponse, undefined>('/payment/intent', undefined);
};

export const collectPaymentIntent = async (
  readerId: string,
  paymentIntentId: string,
): Promise<PaymentApi.CollectPaymentMethodResponse> => {
  return api.post<PaymentApi.CollectPaymentMethodResponse, PaymentApi.CollectPaymentMethodRequest>(
    '/payment/collect',
    {
      readerId,
      paymentIntentId,
    },
  );
};

export const getPaymentIntent = async (
  paymentIntentId: string,
): Promise<PaymentApi.PublicStripePaymentIntent> => {
  return api.get<PaymentApi.PublicStripePaymentIntent>(`/payment/intent/${paymentIntentId}`);
};

export const cancelReaderAction = async (readerId: string): Promise<void> => {
  return api.post<void, PaymentApi.CancelReaderActionRequest>(`/payment/reader/cancel-action`, {
    readerId,
  });
};
